import styled from "styled-components";
import * as h from "../../_themes/helpers";
import { BaseSpinButton } from "../../BaseSpinButton";

export const Wrapper = styled(BaseSpinButton)`
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${h.getHoverColor(
        "spinButtonBackground",
        "spinButton.background"
      )};
      color: ${h.getHoverColor(
        "spinButtonForeground",
        "spinButton.foreground"
      )};
    }
  }

  &:active {
    background: ${h.getPressedColor(
      "spinButtonBackground",
      "spinButton.background"
    )};
    color: ${h.getPressedColor(
      "spinButtonForeground",
      "spinButton.foreground"
    )};
  }

  &[disabled] {
    background: ${h.getDisabledColor(
      "spinButtonBackground",
      "spinButton.background"
    )};
    color: ${h.getDisabledColor(
      "spinButtonForeground",
      "spinButton.foreground"
    )};
  }

  svg {
    pointer-events: none;
  }

  svg > * {
    pointer-events: visible;
  }

  svg:first-child {
    opacity: 1;
  }

  svg:last-child {
    opacity: 0;
  }

  &[data-spin-started="true"] svg:first-child {
    opacity: 0;
  }

  &[data-spin-started="true"] svg:last-child {
    opacity: 1;
  }
`;
